import { Button } from "@mui/material";
import { useFilterContext } from "../../contexts/FilterProvider";
import { blue } from "../../colors";

type ClearFiltersButtonProps = {
  height: number;
};

const ClearFiltersButton = ({ height }: ClearFiltersButtonProps): JSX.Element => {
  const { resetFilters } = useFilterContext();

  return (
    <Button
      variant="outlined"
      fullWidth
      onClick={() => resetFilters()}
      sx={{
        minHeight: height,
        borderRadius: "32px",
        textTransform: "none",
        fontWeight: 500,
        display: "flex",
        justifyContent: "center",
        color: blue[700],
        borderColor: blue[100],
        "&:hover": { borderColor: blue[300], backgroundColor: blue[50] },
      }}
    >
      Reset
    </Button>
  );
};

export default ClearFiltersButton;
